import { render } from "./PracticeQuestions.vue?vue&type=template&id=4a0c62b2&scoped=true"
import script from "./PracticeQuestions.vue?vue&type=script&lang=js"
export * from "./PracticeQuestions.vue?vue&type=script&lang=js"

import "./PracticeQuestions.vue?vue&type=style&index=0&id=4a0c62b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0c62b2"]])

export default __exports__